export default __webpack_public_path__ + "static/media/myadds.6e364396.webp";